import React from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import ErrorBoundary from "./components/ErrorBoundary";
import LandingPage from "./pages/LandingPage";
import Sanctuary from "./pages/Sanctuary";
import Vessels from "./pages/Vessels";
import VesselChat from "./pages/VesselChat";
import Onboarding from "./pages/Onboarding";
import Admin from "./pages/Admin";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import ResetPassword from "./pages/ResetPassword";
import SharedThread from "./pages/SharedThread";
import AgentGuestJoin from "./pages/AgentGuestJoin";
import AuthCallback from "./components/AuthCallback";
import ProtectedRoute from "./components/ProtectedRoute";
import "./App.css";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id synchronously during render (prevents race conditions)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route 
        path="/onboarding" 
        element={
          <ProtectedRoute>
            <Onboarding />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/sanctuary" 
        element={
          <ProtectedRoute>
            <Sanctuary />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/vessels" 
        element={
          <ProtectedRoute>
            <Vessels />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/vessel/:vesselId" 
        element={
          <ProtectedRoute>
            <VesselChat />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/admin" 
        element={
          <ProtectedRoute>
            <Admin />
          </ProtectedRoute>
        } 
      />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/shared/:shareToken" element={<SharedThread />} />
      <Route path="/agent-guest/join/:token" element={<AgentGuestJoin />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <div className="App min-h-screen bg-cosmos-bg">
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <Toaster 
          position="bottom-right"
          toastOptions={{
            style: {
              background: 'rgba(26, 26, 46, 0.9)',
              border: '1px solid rgba(74, 111, 165, 0.3)',
              color: '#e8e8f0',
              backdropFilter: 'blur(20px)',
            },
          }}
        />
      </div>
    </ErrorBoundary>
  );
}

export default App;
